import { deleteCookie, getCookie, setCookie } from './cookie';

export const ABP_ACCOUNT_MANAGER_COOKIE = 'abp-account-manager';
export const ABP_PRODUCT_CODE_COOKIE = 'abp-product-code';

export function getAllianzHeaders() {
  const headers = {};

  const abpAccountManager = getCookie(ABP_ACCOUNT_MANAGER_COOKIE);
  if (abpAccountManager) {
    headers['x-spn-account-manager'] = abpAccountManager;
  }

  const abpProductCode = getCookie(ABP_PRODUCT_CODE_COOKIE);
  if (abpProductCode) {
    headers['x-spn-product-code'] = abpProductCode;
  }

  return headers;
}

function getProductCodeFrom(params) {
  for (const key of params.keys()) {
    if (key.toLocaleLowerCase() === 'simplicity') {
      return 'simplicity';
    }
    if (key.toLocaleLowerCase() === 'vsv') {
      return 'fidelity';
    }
    if (key.toLocaleLowerCase() === 'aval') {
      return 'surety';
    }
  }
  return '';
}

export function flushAllianzCookies() {
  deleteCookie(ABP_ACCOUNT_MANAGER_COOKIE);
  deleteCookie(ABP_PRODUCT_CODE_COOKIE);
}

export function setAllianzCookies() {
  if (hasAllianzParams()) {
    const params = new URLSearchParams(window.location.search);
    setCookie(ABP_ACCOUNT_MANAGER_COOKIE, params.get('accountManager'));
    setCookie(ABP_PRODUCT_CODE_COOKIE, getProductCodeFrom(params));
  }
}

export function hasAllianzParams() {
  const params = new URLSearchParams(window.location.search);
  return params.has('accountManager') || params.has('simplicity') || params.has('aval') || params.has('vsv');
}
